import '../app.css'

function persistBrowserTimezone() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (!timezone) return

  document.cookie = `browser_timezone=${encodeURIComponent(timezone)}; Path=/; SameSite=Lax; Max-Age=31536000`
}

function enhanceMobileNavigation() {
  const menu = document.querySelector<HTMLDetailsElement>('[data-mobile-menu]')
  if (!menu) return

  const close = () => {
    menu.open = false
  }

  menu.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('a, button')) close()
  })
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      close()
      menu.querySelector('summary')?.focus()
    }
  })
  document.addEventListener('click', (event) => {
    if (event.target instanceof Node && !menu.contains(event.target)) close()
  })
}

function enhanceLocaleLinks() {
  document.querySelectorAll<HTMLAnchorElement>('[data-locale-link]').forEach((link) => {
    link.addEventListener('click', () => {
      if (window.location.hash) link.hash = window.location.hash
    })
  })
}

persistBrowserTimezone()
enhanceMobileNavigation()
enhanceLocaleLinks()
